import 'twin.macro';
import styled from 'styled-components';
import Svg from './Svg';

const Icon = styled(Svg)` 
  color: ${(props) => props.color};
  display: inline;
  stroke: ${(props) => props.color};
  height: 17px;
  width: 17px;
  margin: -2px 0 0 8px;
`;

function NewWindow({ color = '#fff' }:{ color?:string }) {
  return (
    <Icon viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
      <path fillRule="evenodd" clipRule="evenodd" d="M14 10.504C14 10.228 14.224 10.004 14.5 10.004C14.776 10.004 15 10.228 15 10.504V13.687C15 14.411 14.411 15 13.687 15H4.312C3.588 15 3 14.411 3 13.686V4.312C3 3.589 3.588 3 4.312 3H7.499C7.775 3 7.999 3.224 7.999 3.5C7.999 3.776 7.775 4 7.499 4H4.312C4.143 4 4 4.143 4 4.312V13.687C4 13.856 4.143 14 4.312 14H13.688C13.856 14 14 13.856 14 13.687V10.504ZM10.5 3.002H13.688C14.411 3.002 15 3.591 15 4.314V7.501C15 7.777 14.776 8.001 14.5 8.001C14.224 8.001 14 7.777 14 7.501V4.79L9.887 9.816C9.788 9.938 9.645 10 9.5 10C9.389 10 9.276 9.963 9.184 9.887C8.97 9.712 8.938 9.397 9.114 9.183L13.354 4.002H10.5C10.224 4.002 10 3.778 10 3.502C10 3.226 10.224 3.002 10.5 3.002Z" fill="white" />
    </Icon>

  );
}

export default NewWindow;
